import { SxProps } from '@mui/material';
import { GLOBAL_MARGIN_HORIZONTAL } from 'src/app/constants';
import { brand } from 'src/themes/palette';

const container: SxProps = {
  flex: 1,
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  paddingTop: GLOBAL_MARGIN_HORIZONTAL,
  paddingBottom: GLOBAL_MARGIN_HORIZONTAL,
  paddingRight: GLOBAL_MARGIN_HORIZONTAL * 2,
  paddingLeft: GLOBAL_MARGIN_HORIZONTAL * 2,
  background: brand.background,
};

const topContainer: SxProps = {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  height: 80,
};

const descContainer: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
};

const graphContainer: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  height: 180,
};

const rankingContainer: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
};

export {
  container,
  topContainer,
  descContainer,
  graphContainer,
  rankingContainer,
};
